 class ReportClientSelectorController {

    constructor(
        $state
    ) {
        'ngInject';

        this.$state = $state;
    }

    /***
     * View a report for the selected clients. Defaults the year value to the current year.
     */
    viewReport(clientList) {
        const currentDate = new Date();
        const year = currentDate.getMonth() > 0 ? currentDate.getFullYear() : currentDate.getFullYear() - 1;

        let clientIds = [];
        clientList.map((client) => clientIds.push(client.id));
        const clientIdList = clientIds.join(',');

        this.$state.go(this.reportState, {
            clientIds: clientIdList,
            year: year
        })
    }

}

export default ReportClientSelectorController;


// WEBPACK FOOTER //
// ./app/common/report-client-selector/report-client-selector-controller.js